<template>
  <div>
    <label class="dias-a-solicitar" :class="primaryTextClass" v-if="state.diasASolicitar > 1">
      <template v-if="state.config.showDetails === true">{{
        $t('message.licenseComponent.licenseBox.discountPlural', {
          saldo: state.diasASolicitar,
          tipo: licenseName.toLowerCase()
        })
      }}</template>
      <template v-else>{{
        $t('message.licenseComponent.licenseBox.registerPlural', {
          saldo: state.diasASolicitar,
          tipo: licenseName.toLowerCase()
        })
      }}</template>
    </label>
    <label
      class="dias-a-solicitar"
      :class="primaryTextClass"
      v-else-if="state.diasASolicitar === 1 && state.request.medioDia === true"
    >
      <template v-if="state.request.hoursRange > 1">{{
        $t('message.licenseComponent.licenseBox.discountHalf', {
          hoursRanges: state.request.hoursRange,
          tipo: licenseName.toLowerCase()
        })
      }}</template>
      <template v-else-if="state.request.hoursRange >= 0.5 && state.request.hoursRange <= 1">{{
        $t('message.licenseComponent.licenseBox.discountHalf', {
          hoursRange: state.request.hoursRange,
          tipo: licenseName.toLowerCase()
        })
      }}</template>
      <template v-else-if="state.config.showDetails && state.request.hoursRange === ''">{{
        $t('message.licenseComponent.licenseBox.discountHalf', {
          tipo: licenseName.toLowerCase()
        })
      }}</template>
      <template v-else>{{
        $t('message.licenseComponent.licenseBox.registerHalf', {
          tipo: licenseName.toLowerCase()
        })
      }}</template>
    </label>
    <label class="dias-a-solicitar" :class="primaryTextClass" v-else>
      <template v-if="state.config.showDetails === true">{{
        $t('message.licenseComponent.licenseBox.discountSingular', {
          saldo: state.diasASolicitar,
          tipo: licenseName.toLowerCase()
        })
      }}</template>
      <template v-else>{{
        $t('message.licenseComponent.licenseBox.registerSingular', {
          saldo: state.diasASolicitar,
          tipo: licenseName.toLowerCase()
        })
      }}</template>
    </label>
  </div>
</template>

<script>
export default {
  name: 'DiscountMessage',
  inject: ['state', 'mutations'],
  props: {
    licenseName: {
      default: '',
      type: String
    },
  },
  data() {
    return {}
  },
  computed: {
    isInIframe() {
      return window.self !== window.top
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100'
    }
  }
}
</script>

<style lang="scss" scoped>
.text-iframe-primary {
  color: #2694fc !important;
}
</style>
